import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full px-4 md:px-6 py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20abstract%20gradient%20background%20with%20flowing%20coral%20and%20peach%20waves%2C%20soft%20atmospheric%20light%20beams%2C%20modern%20minimal%20design%2C%20inspiring%20and%20energetic%20visual%2C%20digital%20art%20style%20with%20smooth%20organic%20shapes%2C%20cinematic%20warm%20color%20grading&width=1600&height=700&seq=cta-bg-kuaimao&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

      <div className="relative z-10 max-w-2xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-white mb-4">
          准备好开始你的创作之旅了吗？
        </h2>
        <p className="text-sm md:text-base text-white/80 mb-8 leading-relaxed">
          加入快猫，与千万创作者一起，让每一份才华都被世界看见。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/short-video"
            className="px-8 py-3 rounded-md bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            立即开始创作
          </Link>
          <Link
            to="/category/monetization"
            className="px-8 py-3 rounded-md border border-white/30 text-white font-medium text-sm hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
          >
            了解变现攻略
          </Link>
        </div>
      </div>
    </section>
  );
}